import { cognito } from '../config/auth';
import { CognitoTokens } from '../utils/authUtils';

class CognitoService {
    private get tokenEndpoint(): string {
        return `https://${cognito.domain}/oauth2/token`;
    }

    private get revokeEndpoint(): string {
        return `https://${cognito.domain}/oauth2/revoke`;
    }

    async exchangeCodeForTokens(code: string): Promise<CognitoTokens> {
        const body = new URLSearchParams({
            grant_type: 'authorization_code',
            client_id: cognito.userPoolWebClientId,
            code,
            redirect_uri: cognito.redirectSignIn,
        });

        const response = await fetch(this.tokenEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body,
        });

        if (!response.ok) {
            const error = await response.text();
            throw new Error(`Token exchange failed: ${error}`);
        }

        return response.json();
    }

    async refreshTokens(refreshToken: string): Promise<CognitoTokens> {
        const body = new URLSearchParams({
            grant_type: 'refresh_token',
            client_id: cognito.userPoolWebClientId,
            refresh_token: refreshToken,
        });

        const response = await fetch(this.tokenEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body,
        });

        if (!response.ok) {
            throw new Error('Token refresh failed');
        }

        return response.json();
    }

    async revokeToken(token: string): Promise<void> {
        const body = new URLSearchParams({
            token,
            client_id: cognito.userPoolWebClientId,
        });

        await fetch(this.revokeEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body,
        });
    }
}

export const cognitoService = new CognitoService();
